import { useState, useCallback } from 'react'

import useApiGet from 'Pods/Shared/Hooks/useApiGet'

const PREVIEW_PATH = '/profile/subscription/plan_switch/preview'

function useSwitchPlanPreview() {
  const [previewData, setPreviewData] = useState(null)
  const { getData, isLoading: isPreviewLoading, error: previewError } = useApiGet()

  const fetchPreview = useCallback(({ to }) => new Promise((resolve) => {
    getData({
      path: PREVIEW_PATH,
      params: { to },
      onSuccess: (response) => {
        setPreviewData(response.data)
        resolve(response.data)
      },
      onError: () => {
        setPreviewData(null)
        resolve(null)
      },
    })
  }), [getData])

  const resetPreview = useCallback(() => {
    setPreviewData(null)
  }, [])

  return {
    previewData,
    isPreviewLoading,
    previewError,
    fetchPreview,
    resetPreview,
  }
}

export default useSwitchPlanPreview
